import { axios } from '@/http/api'
import common from '@/http/response'
const URL = 'driverPlanner/'
import store from '@/store.js'

export default {
  getDriverPlanner (driverId) {
    return axios.get(store.state.apiUrl + "/" + URL + driverId).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  updateDriverPlanner (data) {
    return axios.post(store.state.apiUrl + "/" + URL + data.driverId + "/update", data).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  removeBreak (data) {
    return axios.post(store.state.apiUrl + "/" + URL + data.driverId + "/removeBreak", data).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  removeDayOff (data) {
    return axios.post(store.state.apiUrl + "/" + URL + "/removeDayOff/"  + data.id).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  }
}
